import React, { useState, useEffect } from "react";
import "./PayrollBatch.scss";
import PayrollBatchTabs from "../../components/PayrollBatchTabs/PayrollBatchTabs";
import { getBatchList } from "../../util/API/batch";
import { useSelector } from "react-redux";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import { Box } from "@mui/material";

function PayrollBatch() {
  const [batchList, setBatchList] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // For initial fetch
  const [error, setError] = useState(null); // For fetch failures
  const [securityPermissions, setSecurityPermissions] = useState({});

  const securityAccess = useSelector((state) => state.login.securityAccess);

  useEffect(() => {
    const payrollPermission = searchAppsByLabel("payroll batch", securityAccess);
    if (payrollPermission.length > 0) {
      setSecurityPermissions(payrollPermission[0]);
    }
  }, [securityAccess]);

  useEffect(() => {
    const fetchPayrollBatches = async () => {
      setIsLoading(true); // Ensure loading starts
      setError(null); // Reset error
      try {
        const results = await getBatchList();
        if (results.callStatus == 1) {
          let records = results.payload.record;
          if (!Array.isArray(records)) {
            records = records ? [records] : [];
          }

          // Filter only payroll-related batches by ID
          const payrollBatches = records.filter((batch) => 
            batch.batchfilecategories.categoryid === "33" // Use string comparison; adjust if API returns number
          );

          setBatchList(payrollBatches);
        } else {
          setError("API returned an error status.");
        }
      } catch (err) {
        setError("Failed to load payroll batches: " + err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPayrollBatches();
  }, []);

  const getNewBatchList = (updatedList) => {
    setBatchList(updatedList);
  };

  return (
    <Box className="page-container">
      <Box className="header-container">
        <Box className="page-title">Payroll Batch Services</Box>
      </Box>

      <Box className="batch-tabs">
        {isLoading ? (
          <Box sx={{ p: 8, textAlign: "center", color: "#888" }}>
            Loading payroll batch services...
          </Box>
        ) : error ? (
          <Box sx={{ p: 8, textAlign: "center", color: "red" }}>
            {error} Please try again or contact support.
          </Box>
        ) : (
          <PayrollBatchTabs
            batchList={batchList}
            userPermissions={securityPermissions}
            getNewBatchList={getNewBatchList}
          />
        )}
      </Box>
    </Box>
  );
}

export default PayrollBatch;